import { apiFetch } from './auth';

const BE_BASE = "/api";

/**
* GET /configuration/get
* Restituisce tutte le configurazioni come oggetto nested.
* Con search filtra per prefisso usando la sintassi CrudCompanion:
*   fetchConfigurazione("$chiave:tipoattivita%") → solo le chiavi che iniziano con "tipoattivita"
*   fetchConfigurazione()                         → tutte le configurazioni
*
* La risposta ha la forma { info: { tipoattivita: {...}, cellstyle: {...}, ... } }
*/
export async function fetchConfigurazione(prefisso) {
  const search = prefisso ? `$chiave:${prefisso}%` : undefined;
  const querySearch = search ? `?search=${encodeURIComponent(search)}` : "";

  const res = await apiFetch(`${BE_BASE}/configuration/get${querySearch}`, {
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) throw new Error(`[Config] GET /configuration/get${querySearch} → ${res.status}`);

  const data = await res.json();
  
  return data?.info ?? null;
}
